
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { store, CustomerModule, ShopModule } from "@returns-centre/store";
import { TastyBurgerButton as HamburgerButton } from "vue-tasty-burgers";
import resetIcon from '@returns-centre/resources/reset-icon.svg';

@Component({
    components: {
        HamburgerButton,
    },
})
export default class Navbar extends Vue {
    customerModule = getModule(CustomerModule, store);
    shopModule = getModule(ShopModule, store);
    resetIcon = resetIcon;
    toggle: boolean = false;

    get hasToggle(): boolean {
        return this.toggle;
    }

    onToggle(val: boolean) {
        this.toggle = val;
    }
}
